module.exports = __webpack_public_path__ + "img/cases_02.c6d18f75.jpg";